import React from "react";
import "./InfoBanner.css";
import Pink_btn from "../../../../../common_components/common_btn/pink_btn/Pink_btn";

function InfoBanner() {
  return (
    <div className="Dashboard_InfoBanner">
      <div className="row">
        <div className="col-md-7">
          <div className="text_holder">
            <h3>
              We <span>Nurture</span> <br /> talent across the globe
            </h3>
            <p>
              Join thousands of students transforming their careers through
              international internships and enriching cultural experiences.
            </p>
          </div>
          <div className="btn_holder">
            <Pink_btn btnText="Explore Destinations" />
            <Pink_btn btnText="Learn More" />
          </div>
        </div>

        <div className="col-md-5">
          <div className="stats">
            <div className="row">
              <div className="col-sm-6 col-12">
                <div className="stats_card">
                  <h2> 15+</h2> <p>Partner Countries</p>
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="stats_card">
                  <h2> 200+ </h2> <p>Partner Hotels</p>
                </div>

                <div> </div>
              </div>

              <div className="col-sm-6 col-12">
                <div className="stats_card">
                  <h2> 98% </h2> <p>Satisfaction Rate</p>
                </div>
                <div> </div>
              </div>

              <div className=" col-sm-6 col-12">
                <div className="stats_card">
                  <h2> 24/7</h2> <p>Dedicated Support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoBanner;
